module.exports = __webpack_public_path__ + "img/pricem2.112e0534.svg";